import ErrorMessage from 'components/molecules/error-message'
import { Loader } from 'components/molecules/loader'
import { showHttpToast } from 'lib/show-toast'
import { debounce } from 'lodash'
import { useEffect, useMemo, useState } from 'react'

export function DataProvider({ children, id, orientation = 'vertical', getDataById }) {
    const [data, setData] = useState(null)
    const [code, setCode] = useState(0)
    const [loading, setLoading] = useState(true)

    const load = useMemo(
        () =>
            debounce(async () => {
                setLoading(true)
                const { success, data, message, code } = await getDataById(id)
                if (success) {
                    setData(data)
                    setCode(0)
                } else {
                    setData(null)
                    showHttpToast(success, { description: message })
                    setCode(code)
                }
                setLoading(false)
            }, 300),
        [],
    )

    useEffect(() => {
        load()
    }, [])

    if (loading) return <Loader />
    if (code || !data) {
        return <ErrorMessage type='resource' statusCode={code || 404} orientation={orientation} />
    }

    return children?.(data)
}
